import "chart.js/auto";
import moment from "moment";
import "moment/locale/sv";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-moment';

function MultiLineChart({data, checkedItems, total}: any) {
    const lineChartData = checkedItems.length ? data.datasets.filter((entry: any, index: number) => {
        return entry?.type === checkedItems[index]?.type && checkedItems[index].checked;
    }) : [];

    const isQuarterly = data.labels.length > 12;

    const itemColors = checkedItems.map((checkedItem: any) => checkedItem.color);
    const bgColors = itemColors.filter((color: string|null) => color !== null);

    const datasets = lineChartData.map(({type, ...keepAttrs}: any, index: number) => {
        return {
            ...keepAttrs,
            borderColor: bgColors[index],
            backgroundColor: bgColors[index],
            pointRadius: 2,
            tension: 0.1,
            fill: false,
        }
    });

    const chartData= {
        labels: data.labels,
        datasets: datasets
    };

    if (!checkedItems.length) {
        return <></>;
    }

    return <Line
        data={chartData}
        height='240'
        options={{
            animation: false,
            scales: {
                x: {
                    ticks: {
                        align: isQuarterly ? 'center' : 'start',
                        color: '#F9F9FA',
                        stepSize: isQuarterly ? 3 : 2,
                    },
                    grid: {
                        display: false,
                    },
                    type: 'time',
                    time: {
                        unit: isQuarterly ? "quarter" : "month",
                        tooltipFormat: isQuarterly ? '[Q]Q-YYYY' : 'MMMM YYYY',
                        displayFormats: {
                            month: 'MMM-YY',
                            quarter: '[Q]Q/YY',
                        }
                    },
                },
                y: {
                    beginAtZero: true,
                    grid: {
                        color: '#545B66',
                        drawTicks: false,
                    },
                    border: {
                        display: false,
                    },
                    title: {
                        display: true,
                        text: 'Antal jobbannonser',
                        color: '#C8C8CE',
                        font: {
                            size: 10,
                        },
                        padding: 0,
                    },
                    ticks: {
                        crossAlign: 'near',
                        padding: 10,
                        maxTicksLimit: 7,
                        color: '#F9F9FA',
                        callback: (value) => {
                            return value.toLocaleString('sv');
                        },
                    },
                }
            },
            plugins: {
                title: {
                    display: false,
                },
                legend: {
                    display: false,
                },
                tooltip: {
                    callbacks: {
                        beforeTitle: (item) => {
                            return item[0].dataset.label ?? '';
                        },
                        label: (item) => {
                            return ' ' + item.formattedValue.replace(',', ' ');
                        }
                    },
                },
            }
        }}
    />
}

export default MultiLineChart;